import PlayPlaylist from './PlayPlaylist'

export default PlayPlaylist
// eslint-disable-next-line import/export
export * from './PlayPlaylist'
